export default {
    'ERROR-GET-CAMPAIGN-DATA-SIGN-UP-HELPER-PUBLIC': {
        'ERROR-CAMPAIGN-UUID-REQUIRED': {
            actionType: 'redirect',
            message: {
                fr: "L'UUID de la campagne est requis.",
                en: 'Campaign UUID is required.',
            },
            redirectPath: '/',
        },
        'ERROR-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Campagne non trouvée.",
                en: 'Campaign not found.',
            },
            redirectPath: '/campaign-not-found',
        },
        'ERROR-CAMPAIGN-ARCHIVED': {
            actionType: 'redirect',
            message: {
                fr: "Cette campagne a été archivée.",
                en: 'This campaign has been archived.',
            },
            redirectPath: '/campaign-archived',
        },
        'ERROR-CAMPAIGN-NOT-LAUNCHED': {
            actionType: 'redirect',
            message: {
                fr: "Cette campagne n'a pas encore été lancée.",
                en: 'This campaign has not been launched yet.',
            },
            redirectPath: '/campaign-not-launched',
        },
    },
    'ERROR-GET-CAMPAIGN-DATA-SIGN-UP-HELPER': {
        'ERROR-CAMPAIGN-UUID-REQUIRED': {
            actionType: 'redirect',
            message: {
                fr: "L'UUID de la campagne est requis.",
                en: 'Campaign UUID is required.',
            },
            redirectPath: '/',
        },
        'ERROR-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Campagne non trouvée.",
                en: 'Campaign not found.',
            },
            redirectPath: '/campaign-not-found',
        },
        'ERROR-CAMPAIGN-ARCHIVED': {
            actionType: 'redirect',
            message: {
                fr: "Cette campagne a été archivée.",
                en: 'This campaign has been archived.',
            },
            redirectPath: '/campaign-archived',
        },
        'ERROR-CAMPAIGN-NOT-LAUNCHED': {
            actionType: 'redirect',
            message: {
                fr: "Cette campagne n'a pas encore été lancée.",
                en: 'This campaign has not been launched yet.',
            },
            redirectPath: '/campaign-not-launched',
        },
        'ERROR-USER-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Utilisateur non trouvé.",
                en: 'User not found.',
            },
            redirectPath: '/',
        },
        'ERROR-USER-NOT-IN-ORGANIZATION': {
            actionType: 'redirect',
            message: {
                fr: "Utilisateur non trouvé dans cette organisation.",
                en: 'User not found in this organization.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-REGISTER-CAMPAIGN-SIGN-UP-HELPER-EMAIL': {
        'ERROR-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Campagne non trouvée.",
                en: 'Campaign not found.',
            },
            redirectPath: '/',
        },
        'ERROR-CAMPAIGN-ARCHIVED-BY-ADMIN': {
            actionType: 'redirect',
            message: {
                fr: "Cette campagne a été archivée par un administrateur.",
                en: 'This campaign has been archived by an admin.',
            },
            redirectPath: '/',
        },
        'ERROR-USER-NOT-CREATED': {
            actionType: 'redirect',
            message: {
                fr: "Utilisateur non créé.",
                en: 'User not created.',
            },
        },
    },
    'ERROR-REGISTER-PHONE-SIGN-UP-HELPER': {
        'ERROR-PHONE-NOT-VALID': {
            actionType: 'toast',
            message: {
                fr: 'Le numéro de téléphone n\'est pas valide.',
                en: 'The phone number is not valid.',
            },
        },
        'ERROR-USER-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: 'Utilisateur non trouvé.',
                en: 'User not found.',
            },
            redirectPath: '/',
        },
        'ERROR-PHONE-ALREADY-VERIFIED': {
            actionType: 'toast',
            message: {
                fr: 'Le numéro de téléphone est déjà vérifié.',
                en: 'The phone number is already verified.',
            },
        },
        'ERROR-INVALID-PHONE-NUMBER': {
            actionType: 'toast',
            message: {
                fr: 'Le numéro de téléphone est invalide.',
                en: 'The phone number is invalid.',
            },
        },
        'ERROR-WHILE-SENDING-CODE': {
            actionType: 'toast',
            message: {
                fr: 'Erreur lors de l\'envoi du code.',
                en: 'Error while sending the code.',
            },
        },
    },
    'ERROR-VERIFY-CODE-CAMPAIGN-SIGN-UP-HELPER': {
        'ERROR-NO-PHONE-VERIFICATION-FOUND': {
            actionType: 'toast',
            message: {
                fr: 'Aucune vérification de téléphone trouvée.',
                en: 'No phone verification found.',
            },
        },
        'ERROR-INVALID-CODE': {
            actionType: 'toast',
            message: {
                fr: 'Le code est invalide.',
                en: 'The code is invalid.',
            },
        },
        'code is required': {
            actionType: 'toast',
            message: {
                fr: 'Le code est requis.',
                en: 'Code is required.',
            },
        },
        'code must be a number': {
            actionType: 'toast',
            message: {
                fr: 'Le code doit être un nombre.',
                en: 'Code must be a number.',
            },
        },
    },
    'ERROR-UPDATE-NAME-CAMPAIGN-SIGN-UP-HELPER': {
        'UPDATE-FIELDS-USER-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: 'Utilisateur non trouvé.',
                en: 'User not found.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-UPDATE-USER-PROFILE-PICTURE-CAMPAIGN-SIGN-UP-HELPER': {
        'ERROR-NO-FILE-UPLOADED': {
            actionType: 'toast',
            message: {
                fr: 'Aucun fichier téléchargé.',
                en: 'No file uploaded.',
            },
        },
        'ERROR-NO-FILE-TO-UPLOAD': {
            actionType: 'toast',
            message: {
                fr: 'Aucun fichier à télécharger.',
                en: 'No file to upload.',
            },
        },
        'ERROR-NO-PROFILE-PICTURE-UPLOADED': {
            actionType: 'toast',
            message: {
                fr: 'Aucune photo de profil téléchargée.',
                en: 'No profile picture uploaded.',
            },
        },
        'ERROR-UPDATE-PROFILE-PICTURE': {
            actionType: 'toast',
            message: {
                fr: 'Erreur lors de la mise à jour de la photo de profil.',
                en: 'Error updating profile picture.',
            },
        },
    },
    'ERROR-ADD-CRITERIA-CAMPAIGN-SIGN-UP-HELPER': {
        'ERROR-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Campagne non trouvée.",
                en: 'Campaign not found.',
            },
            redirectPath: '/campaign-not-found',
        },
        'ERROR-USER-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: 'Utilisateur non trouvé.',
                en: 'User not found.',
            },
            redirectPath: '/',
        },
        'ERROR-CRITERIA-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Critère non trouvé dans la campagne.",
                en: 'Criteria not found in campaign.',
            },
        },
        'ADD-OR-UPDATE-CRITERIA-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Critère non trouvé.",
                en: 'Criteria not found.',
            },
        },
        'ADD-OR-UPDATE-ANSWER-KEY-REQUIRED': {
            actionType: 'toast',
            message: {
                fr: "Clé de réponse requise.",
                en: 'Answer key required.',
            },
        },
        'ADD-OR-UPDATE-ANSWER-KEY-NOT-FOUND-IN-CRITERIA-OPTIONS': {
            actionType: 'toast',
            message: {
                fr: "Clé de réponse non trouvée dans les options du critère.",
                en: 'Answer key not found in criteria options.',
            },
        },
        'ADD-OR-UPDATE-ANSWER-KEYS-REQUIRED': {
            actionType: 'toast',
            message: {
                fr: "Clés de réponse requises.",
                en: 'Answer keys required.',
            },
        },
        'ADD-OR-UPDATE-SOME-ANSWER-KEYS-NOT-FOUND-IN-CRITERIA-OPTIONS': {
            actionType: 'toast',
            message: {
                fr: "Certaines clés de réponse non trouvées dans les options du critère.",
                en: 'Some answer keys not found in criteria options.',
            },
        },
    },
    'ERROR-ADD-TOUCH-POINTS-CAMPAIGN-SIGN-UP-HELPER': {
        'ERROR-USER-TOUCH-POINTS-NOT-ARRAY': {
            actionType: 'toast',
            message: {
                fr: "Les points de contact de l'utilisateur ne sont pas un tableau.",
                en: "User touch points is not an array.",
            },
        },
        'ERROR-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Campagne non trouvée.",
                en: 'Campaign not found.',
            },
            redirectPath: '/campaign-not-found',
        },
        'ERROR-USER-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: 'Utilisateur non trouvé.',
                en: 'User not found.',
            },
            redirectPath: '/',
        },
        'ADD-OR-UPDATE-TOUCH-POINT-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: 'Point de contact non trouvé.',
                en: 'Touch point not found.',
            },
        },
    },
};
